import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { enrichStale } from "@/services/adminApi";
import { Clock, Loader2 } from "lucide-react";

interface Props {
  entity: "candidates" | "companies" | "schools";
  label: string;
}

export default function EnrichStaleDialog({ entity, label }: Props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(() => {
    const d = new Date();
    d.setMonth(d.getMonth() - 3);
    return d.toISOString().slice(0, 10);
  });
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  const handleSubmit = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await enrichStale(navigate, entity, date);
      setResult(`${res.queued} ${label.toLowerCase()} mis en file d'enrichissement`);
    } catch (e) {
      setResult(`Erreur: ${e instanceof Error ? e.message : "inconnue"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => { setOpen(true); setResult(null); }}>
        <Clock className="h-3.5 w-3.5 mr-1.5" />
        Enrichir donnees anciennes
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>Enrichir {label.toLowerCase()} anciens</DialogTitle>
          </DialogHeader>
          <div className="space-y-3 py-2">
            <div className="space-y-1.5">
              <Label className="text-sm">Enrichir les {label.toLowerCase()} mis a jour avant le :</Label>
              <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
            </div>
            {result && (
              <p className={`text-sm ${result.startsWith("Erreur") ? "text-red-600" : "text-green-600"}`}>{result}</p>
            )}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Fermer</Button>
            <Button onClick={handleSubmit} disabled={loading || !date}>
              {loading ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : null}
              Lancer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
